const initialState = {
    user: {
        idAfiliado: "",
        idEmpresa: "",
        primerNombre: "",
        segundoNombre: "",
        primerApellido: "",
        segundoApellido: "",
        tipoIdentificacion: "",
        numeroIdentificacion: "",
        genero: "",
        fechaNacimiento: "",
        estadoCivil: "",
        telefono: "",
        numeroCelular: "",
        correoElectronico: "",
        cargo: "",
        salario: 0,
        cantidadHijos: 0,
        cupoAsignado: "",
        estado: "1",
        causalEstado: "",
        fechaIngreso: "",
        tieneMoto: "",
        tieneCarro: "",
        eps: {},
        afp: {},
        arl: {},
        ccf: {},
        administradoras: [{
            idAdministradora: '',
            nombre: '',
            tipoAdmin: ''
        },
        {
            idAdministradora: '',
            nombre: '',
            tipoAdmin: ''
        },
        {
            idAdministradora: '',
            nombre: '',
            tipoAdmin: ''
        },
        {
            idAdministradora: '',
            nombre: '',
            tipoAdmin: ''
        },
        ]
    },
};

const state = {
    loading: false,
    typesIdentification: [],
    genders: [],
    civilStatus: [],
    listTypesEps: [],
    listTypesAfp: [],
    listTypesArl: [],
    listTypesCcf: [],
    users: [],
    detailUser: { ...initialState.user },
};

export { state, initialState };